<div class="content-div">
   <div class="auto-refresh-warning" *ngIf="anySelected">
     <i class="fal fa-exclamation-triangle"></i>
      {{ 'realtime:queuedetails_lang_stoprefresh' | i18next : { defaultValue: 'Auto refresh paused while items are selected.' } }}
    </div>

  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
       <app-basic-button id="help-btn-ongoing-requests" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'menu:RealtimeOngoingCalls' | i18next : { defaultValue: 'Ongoing requests' } }}</span>
  </div>
 <div class="connected-agents">
      {{ 'realtime:RealtimeConnectedAgents' | i18next : { defaultValue: 'Connected agents' } }}
      <span class="count">{{ connectedCount }}</span>
    </div>
  <div class="top-bar buttons-bar">
    <app-basic-button id="select-all-btn-ongoing-requests" *ngIf="!allSelected && propertyAllowDelete" type="secondary" [text]="'Select all' | i18next"  size="small" [disabled]="!anySelectable"
      (click)="toggleSelectAll(true)"></app-basic-button>
    <app-basic-button id="deselect-all-btn-ongoing-requests" *ngIf="allSelected && propertyAllowDelete" type="secondary" [text]="'Deselect all' | i18next" size="small"
      (click)="toggleSelectAll(false)"></app-basic-button>

 <app-basic-button id="delete-selected-btn-ongoing-requests" type="decline" size="small" *ngIf="propertyAllowDelete" [disabled]="!anySelected" (click)="onDeleteSelected()">
        <i class="fal fa-times fs-14"></i> {{ 'reports:Delete' | i18next : { defaultValue: 'Delete' } }}
    </app-basic-button>

    <div class="right">
      <app-filter-input id="filter-input-ongoing-requests" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
    </div>
  </div>

  <div class="content">


    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>


    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

  <!-- Select -->
      <ng-container *ngIf="propertyAllowDelete" matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="text-center">
          <!-- <label class="inline-flex items-center gap-2 cursor-pointer select-none">
            <input type="checkbox"
                   [checked]="allSelected"
                   (change)="toggleSelectAll($event.target.checked)" />
            {{ 'realtime:queuedetails_lang_select' | i18next : { defaultValue: 'Select' } }}
          </label> -->
        </th>
        <td mat-cell *matCellDef="let r" class="text-center">
          <app-basic-checkbox id="checkbox-{{r.requestId}}-ongoing-requests" [disabled]="!r.finalDelete" [model]="selected[r.requestId] || false" (change)="toggleOne(r.requestId, $event)" [attr.data-media]="r.mediaType" [disabled]="!r.finalDelete"></app-basic-checkbox>
          <!-- <input type="checkbox"
                 [disabled]="!r.finalDelete"
                 [checked]="selected[r.requestId] || false"
                 (change)="toggleOne(r.requestId, $event.target.checked)" /> -->
        </td>
      </ng-container>

      <!-- Queue -->
      <ng-container matColumnDef="queueName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:queue' | i18next : { defaultValue: 'Queue' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left" [title]="r.queueName">{{ r.queueName }}</td>
      </ng-container>

      <!-- Profile description -->
      <ng-container matColumnDef="requestDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:profile_description' | i18next : { defaultValue: 'Description' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left description-td" [title]="r.requestDescription || '‒'">
          {{ r.shortDescription || '‒' }}
        </td>
      </ng-container>

      <!-- Type (colored) -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:queuedetails_Type' | i18next : { defaultValue: 'Type' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left">
          <span class="type-pill" [ngStyle]="{ 'background-color': r.bColorType, 'color': r.fColorType }">
            {{ r.formattedType }}
          </span>
        </td>
      </ng-container>

      <!-- Number / Source -->
      <ng-container matColumnDef="requestSource">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:ongoingcalls_number' | i18next : { defaultValue: 'Number' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left">
          {{ r.requestSource || '‒' }}
        </td>
      </ng-container>

      <!-- Connected duration -->
      <ng-container matColumnDef="connected">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:ongoingcalls_duration' | i18next : { defaultValue: 'Duration' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.formattedConnectedDuration }}
        </td>
      </ng-container>

      <!-- Agent -->
      <ng-container matColumnDef="agent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:agent' | i18next : { defaultValue: 'Agent' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left">
          {{ r.userName || '—' }}
        </td>
      </ng-container>

      <!-- Agent status -->
      <ng-container matColumnDef="agentStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left">
          {{ 'realtime:agentstatus_status' | i18next : { defaultValue: 'Status' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left">
          <span class="status">
               <i *ngIf="!(r.contactCentreStatus == 0 && r.userName == null)"
     class="fas fa-circle status-color fs-10"
     [style.color]="r.statusColor">
  </i>

  {{ (r.contactCentreStatus == 0 && r.userName == null) ? '-' : r.formattedStatus }}
          </span>
        </td>
      </ng-container>

      <!-- Status duration -->
      <ng-container matColumnDef="statusDuration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="right">
          {{ 'realtime:statusduration' | i18next : { defaultValue: 'Status duration' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ r.formattedTimeInStatus }}
        </td>
      </ng-container>



      <!-- header & rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          [attr.id]="row.requestId">
      </tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>
    </table>
<div *ngIf="errorMessage" class="table-error" role="alert" aria-live="polite">
  {{ errorMessage }}
</div>

  </div>
</div>
